/**
 * Custom hook for media query matching
 */

import { useState, useEffect } from 'react';

/**
 * Hook that returns whether a media query matches
 * @param {string} query - CSS media query string
 * @returns {boolean} Whether the query matches
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = (event) => {
      setMatches(event.matches);
    };

    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query, matches]);

  return matches;
}

/**
 * Hook that returns common breakpoint states
 * @returns {Object} Breakpoint booleans
 */
export function useBreakpoints() {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');
  const isDesktop = useMediaQuery('(min-width: 992px)');

  return { isMobile, isTablet, isDesktop };
}
